import { Card, Grid } from "@mantine/core";
import { ContrastSensitivityData, PelliRobsonResult } from "types/testTypes";
import { useEffect, useState } from "react";

import ContrastSensitivityChart from "../../common/ContrastSensitivityChart";
import VAcuityResultLine from "@components/testContainer/common/VAcuityResultLine";

export default function ContrastSensitivityTestEntry({ entry }) {
  const receivedContrastSensitivityTestResult = entry as any;
  // todo: (Hopefully) temporarily we have added any to type to ensure backwards compatibility. During Pelli-Robson development we had changed the result object model.
  // We should refactor this to type ContrastSensitivityTestResult as soon as possible.
  const [contrastResults, setContrastResults] = useState<ContrastSensitivityData[] | null>(null);
  const [pelliRobsonResult, setPelliRobsonResult] = useState<PelliRobsonResult | null>(null);

  useEffect(() => {
    if (receivedContrastSensitivityTestResult) {
      setContrastResults(
        receivedContrastSensitivityTestResult.results?.contrastResults ||
          (receivedContrastSensitivityTestResult.results as ContrastSensitivityData[]), // todo Again. Once we can decide that we don't need the old version. We can remove this cast.
      );
      setPelliRobsonResult(receivedContrastSensitivityTestResult.results?.pelliRobsonResults);
    }
  }, [receivedContrastSensitivityTestResult]);

  return (
    <Card withBorder shadow="md" radius="md" mb="md">
      {contrastResults && contrastResults.length > 0 && (
        <ContrastSensitivityChart data={contrastResults} />
      )}
      <Grid columns={19} align="center">
        {pelliRobsonResult?.lineResults &&
          pelliRobsonResult.lineResults.map((lineResult, index) => (
            <VAcuityResultLine
              key={index}
              row={index}
              isActive={false}
              letters={lineResult.letters.map((l) => l.letter)}
              isResultLine={index === pelliRobsonResult.lineResults.length - 1}
              hideInfo={true}
              rowResults={lineResult.letters.map((l) => (l.isTrue ? 1 : 0))}
            />
          ))}
      </Grid>
    </Card>
  );
}
